"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("es6-shim");
require("whatwg-fetch");
var classNames = require("classnames");
var _ = require("lodash");
var React = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var ReactDOM = require("react-dom");
var AllPermissions_1 = require("../shared/model/AllPermissions");
var utilities_1 = require("../shared/utilities");
var Notifications = require("./NotificationMessageNotifier");
var NotificationMessageNotifier = Notifications.NotificationMessageNotifier;
var App = (function (_super) {
    tslib_1.__extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.base = "";
        _this.currentAgentGroupEnvironment = {};
        _this.getAuthenticationItems = function () {
            if (_this.props.isAuthenticated === "True") {
                if (_this.props.isSigninsupported === "True") {
                    return React.createElement(react_bootstrap_1.NavDropdown, { pullRight: true, id: "signout-dropdown", title: _this.props.username },
                        React.createElement(react_bootstrap_1.MenuItem, { href: _this.base + "Account/SignOut" }, FRENDS.Localizations.SignOut));
                }
                else {
                    return React.createElement("li", { role: "presentation" },
                        React.createElement("p", { className: "navbar-text" },
                            React.createElement("span", { className: "glyphicon glyphicon-user" }),
                            " ",
                            _this.props.username));
                }
            }
            else if (_this.props.isSigninsupported === "True") {
                return React.createElement(react_bootstrap_1.NavItem, { href: _this.base + "Account/SignIn" }, FRENDS.Localizations.SignIn);
            }
        };
        _this.getDropdownMenu = function (link, linkIndex) {
            var menuItems = link.children.map(function (childLink, childLinkIndex) {
                if (_this.state.hasRightsFor[childLink.permission]) {
                    var linkId = "nav_link_" + linkIndex + "_" + childLinkIndex;
                    return React.createElement(react_bootstrap_1.MenuItem, { id: linkId, key: linkId, className: classNames("dropdown-menu-item menu-item-reversed-padding", { selected: (_this.state.activeLink === childLink.activeLinkName) }), href: _this.generateHref(childLink) }, childLink.label);
                }
                else {
                    return null;
                }
            });
            return React.createElement(react_bootstrap_1.NavDropdown, { id: "nav_link_" + linkIndex, key: "nav_link_" + linkIndex, eventKey: linkIndex, title: link.label, className: classNames({ active: (link.children.some(function (x) { return x.activeLinkName === _this.state.activeLink; })) }) }, menuItems);
        };
        _this.generateHref = function (link) {
            if (!link.overwriteCurrentEnvironmentInUrl) {
                return _this.base + link.href;
            }
            var environment = _this.getEnvironmentFromUrl();
            return _this.base + link.href + environment.environmentName + (link.useAgentGroups ? environment.agentGroupName : "");
        };
        _this.state = {
            activeLink: undefined,
            hasRightsFor: {}
        };
        _this.tick = _this.tick.bind(_this);
        _this.tickIntervalId = setInterval(_this.tick, 500);
        return _this;
    }
    App.prototype.componentDidMount = function () {
        try {
            this.setState({ hasRightsFor: utilities_1.Utilities.getAllUserPermissions() });
        }
        catch (exception) {
            console.error("Unable to retrive user permissions: " + exception);
            throw exception;
        }
        this.updateState();
    };
    App.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Navbar, { className: "navbar-static-top" },
            React.createElement(react_bootstrap_1.Navbar.Header, null,
                React.createElement(react_bootstrap_1.Navbar.Brand, null,
                    React.createElement("a", { href: this.base + "Dashboard" },
                        React.createElement("img", { src: this.base + "Content/Images/frends_logo.svg", width: "150", height: "32" }))),
                React.createElement(react_bootstrap_1.Navbar.Toggle, null)),
            React.createElement(react_bootstrap_1.Navbar.Collapse, null,
                React.createElement(react_bootstrap_1.Nav, { id: "menu" }, navigationBarData.map(function (link, linkIndex) {
                    return _this.state.hasRightsFor[link.permission] ?
                        link.children != null
                            ? _this.getDropdownMenu(link, linkIndex)
                            : React.createElement(react_bootstrap_1.NavItem, { href: _this.generateHref(link), className: classNames({ active: (_this.state.activeLink === link.activeLinkName) }), key: link.activeLinkName }, link.label)
                        : null;
                })),
                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                    React.createElement(react_bootstrap_1.NavItem, { target: "_blank", href: "https://frends.com/docs" }, FRENDS.Localizations.Help),
                    this.getAuthenticationItems()),
                React.createElement(NotificationMessageNotifier, { className: "hide-for-small-screen" }))));
    };
    App.prototype.tick = function () {
        try {
            var env = this.getEnvironmentFromUrl();
            if (!_.isEqual(env, this.currentAgentGroupEnvironment)) {
                this.updateState();
            }
        }
        catch (ex) {
            clearInterval(this.tickIntervalId);
            throw ex;
        }
    };
    App.prototype.updateState = function () {
        this.base = document.getElementsByTagName("base")[0].href;
        this.currentAgentGroupEnvironment = this.getEnvironmentFromUrl();
        var urlParts = this.getUriPartsWithoutBase();
        var controller = urlParts[0];
        this.setState({ activeLink: LinkNames[controller.toLowerCase()] });
    };
    App.prototype.getUriPartsWithoutBase = function () {
        var urlPart = window.location.href;
        var basePart = this.base;
        var urlPartWithoutBase = urlPart.replace(basePart, "").split("/");
        return urlPartWithoutBase;
    };
    App.prototype.getEnvironmentFromUrl = function () {
        var urlParts = this.getUriPartsWithoutBase();
        var environmentPart = "";
        var agentGroupPart = "";
        switch (this.state.activeLink) {
            case LinkNames.process:
            case LinkNames.subprocess:
                if ((urlParts[1] === "List") && urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                    agentGroupPart = urlParts.length >= 4 ? "/" + urlParts[3] : "";
                }
                break;
            case LinkNames.environmentvariables:
            case LinkNames.monitoringrules:
                if (urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                }
                break;
            case LinkNames.environment:
            case LinkNames.apimanagement:
                if (urlParts.length >= 2) {
                    environmentPart = "/" + urlParts[1];
                    agentGroupPart = urlParts.length >= 3 ? "/" + urlParts[2] : "";
                }
                break;
            default:
                environmentPart = "";
        }
        return { agentGroupName: agentGroupPart, environmentName: environmentPart };
    };
    return App;
}(React.Component));
var LinkNames;
(function (LinkNames) {
    LinkNames[LinkNames["apimanagement"] = 0] = "apimanagement";
    LinkNames[LinkNames["process"] = 1] = "process";
    LinkNames[LinkNames["subprocess"] = 2] = "subprocess";
    LinkNames[LinkNames["environmentvariables"] = 3] = "environmentvariables";
    LinkNames[LinkNames["administration"] = 4] = "administration";
    LinkNames[LinkNames["environment"] = 5] = "environment";
    LinkNames[LinkNames["task"] = 6] = "task";
    LinkNames[LinkNames["monitoringrules"] = 7] = "monitoringrules";
    LinkNames[LinkNames["usermanagement"] = 8] = "usermanagement";
    LinkNames[LinkNames["apikeymanagement"] = 9] = "apikeymanagement";
    LinkNames[LinkNames["apiaccesspolicymanagement"] = 10] = "apiaccesspolicymanagement";
    LinkNames[LinkNames["settings"] = 11] = "settings";
})(LinkNames || (LinkNames = {}));
var navigationBarData = [
    { href: "ApiManagement", activeLinkName: LinkNames.apimanagement, label: FRENDS.Localizations.ApiManagement, permission: AllPermissions_1.Permissions.ApiManagementView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "Process/List", activeLinkName: LinkNames.process, label: FRENDS.Localizations.Processes, permission: AllPermissions_1.Permissions.ProcessView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "SubProcess/List", activeLinkName: LinkNames.subprocess, label: FRENDS.Localizations.Subprocesses, permission: AllPermissions_1.Permissions.SubProcessEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "EnvironmentVariables/List", activeLinkName: LinkNames.environmentvariables, label: FRENDS.Localizations.EnvironmentVariables, permission: AllPermissions_1.Permissions.EnvironmentVariablesEdit, overwriteCurrentEnvironmentInUrl: true },
    {
        href: "", activeLinkName: LinkNames.administration, label: FRENDS.Localizations.Administration, permission: AllPermissions_1.Permissions.AdministrationView, overwriteCurrentEnvironmentInUrl: false,
        children: [
            { href: "Environment", activeLinkName: LinkNames.environment, label: FRENDS.Localizations.Environments, permission: AllPermissions_1.Permissions.EnvironmentEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
            { href: "Task", activeLinkName: LinkNames.task, label: FRENDS.Localizations.Tasks, permission: AllPermissions_1.Permissions.TaskView, overwriteCurrentEnvironmentInUrl: false },
            { href: "MonitoringRules/List", activeLinkName: LinkNames.monitoringrules, label: FRENDS.Localizations.MonitoringRules, permission: AllPermissions_1.Permissions.MonitoringRulesView, overwriteCurrentEnvironmentInUrl: true },
            { href: "UserManagement", activeLinkName: LinkNames.usermanagement, label: FRENDS.Localizations.UserManagement_Users, permission: AllPermissions_1.Permissions.UserManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiKeyManagement", activeLinkName: LinkNames.apikeymanagement, label: FRENDS.Localizations.Administration_ApiKeys, permission: AllPermissions_1.Permissions.ApiKeyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiAccessPolicyManagement", activeLinkName: LinkNames.apiaccesspolicymanagement, label: FRENDS.Localizations.ApiAccessPolicies, permission: AllPermissions_1.Permissions.ApiAccessPolicyManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "Settings", activeLinkName: LinkNames.settings, label: FRENDS.Localizations.Settings, permission: AllPermissions_1.Permissions.SettingsAdmin, overwriteCurrentEnvironmentInUrl: false }
        ]
    }
];
var navigationContainer = document.getElementById("navigationbar");
if (navigationContainer) {
    var render = function (Component) { return ReactDOM.render((React.createElement(Component, tslib_1.__assign({}, (navigationContainer.dataset)))), navigationContainer); };
    render(App);
}
